import React from "react";

export const ChatWindowStateContext = React.createContext(null);
export const ChatWindowStateSetterContext = React.createContext(null);

export const ChatWindowStateProvider = ChatWindowStateContext.Provider;
export const ChatWindowStateSetterProvider = ChatWindowStateSetterContext.Provider;
